import { useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';

import PrimaryButton from '../../FormElements/PrimaryButton';
import Modal from '../../UIelements/Modal';
import Loading from '../../Loading';

import { deleteTutorials } from '../../../services';

import { useDispatch } from 'react-redux';
import { setRunTutorials } from '../../../store/configs/tutorialsSlice';

import * as Styled from './styles';

type ModalProps = {
  idUser: number;
  token: string;
  onCancel: () => void;
  onUpdateList: () => Promise<void>;
};

const ModalReviewTutorials = (props: ModalProps) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await deleteTutorials(props.idUser, props.token);
      toast.success(intl.formatMessage({ id: 'main.Tutoriais resetados com sucesso!' }).toUpperCase());
      dispatch(setRunTutorials(true));
      await props.onUpdateList();
      props.onCancel();
    } catch (error) {
      console.error(error);
      toast.error(intl.formatMessage({ id: 'equipment.ocorreu um erro. Tente novamente mais tarde' }).toUpperCase());
    } finally {
      setIsLoading(false);
    }
  };
  

  const content = (
    <>
      <Styled.Paragraph>
        {intl.formatMessage({ id: 'main.review.tutorials' })}
      </Styled.Paragraph>
      <Styled.Paragraph>
          {intl.formatMessage({ id: 'main.review.manual' })}
      </Styled.Paragraph>
    </>
  );

  const loading = <Loading />;

  const footer = (
    <>
      <PrimaryButton
        type='button'
        size='buttonModal'
        model='confirmation-gradient-modal'
        width='108px'
        onClick={handleSubmit}
      >
        {intl.formatMessage({ id: 'equipment.sim' })}
      </PrimaryButton>
      <PrimaryButton
        type='button'
        size='buttonModal'
        model='cancellation'
        width='108px'
        onClick={props.onCancel}
      >
        {intl.formatMessage({ id: 'equipment.não' })}
      </PrimaryButton>
    </>
  );
  return (
    <Modal
      title={intl.formatMessage({ id: 'main.Rever tutoriais' })}
      width='400px'
      showButtonClose={false}
      children={isLoading ? loading : content}
      footer={footer}
      onCancel={props.onCancel}
      onSubmit={handleSubmit}
    />
  );
};

export default ModalReviewTutorials;
